import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

function DatetimeEditor(value, edit) {
  return edit ? (
    <DatePicker className="form-control form-control-sm" />
  ) : moment(value).isValid() ? (
    moment(value).format("DD/MM/YYYY HH:mm:ss")
  ) : (
    value?.toString()
  );
}

export default DatetimeEditor;
